import Chart from "chart.js/auto";

const createDonutChart = (ctx, label, percentage, color, labelColor) => {
    if (!ctx) {
        console.warn(`Canvas context for ${label} not found.`);
        return;
    }

    // Destroy existing chart if present
    if (ctx.chart) {
        ctx.chart.destroy();
    }

    // Create new chart instance
    ctx.chart = new Chart(ctx, {
        type: "doughnut",
        data: {
            labels: [label, "Remaining"],
            datasets: [
                {
                    data: [percentage, 100 - percentage],
                    backgroundColor: [color, "#e0e0e0"],
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    labels: { color: labelColor },
                },
            },
            cutout: "70%", // Makes it look like a donut chart
        },
    });
};

export default createDonutChart;
